export const darkenColor = (color: string, percent: number) => {
    if (!color.startsWith("#")) return color; // Ensure it's a valid hex color
  
    let num = parseInt(color.slice(1), 16),
      amt = Math.round(2.55 * percent),
      r = (num >> 16) - amt,
      g = ((num >> 8) & 0x00ff) - amt,
      b = (num & 0x0000ff) - amt;
  
    return `rgb(${Math.max(r, 0)}, ${Math.max(g, 0)}, ${Math.max(b, 0)})`;
  };
  